var _rect, _g, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 11,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_1121)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 14,
    height: 2,
    rx: 1,
    transform: "rotate(-90 15 30)",
    fill: "#424040"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#424040"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 6,
    height: 2,
    rx: 0.5,
    transform: "rotate(90 30 20)",
    fill: "#424040"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22,
    width: 6,
    height: 2,
    rx: 0.5,
    transform: "rotate(-180 30 22)",
    fill: "#424040"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 32,
    r: 3,
    fill: "#424040",
    stroke: "#424040",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 5,
    height: 2,
    rx: 0.5,
    transform: "rotate(-90 34 20)",
    fill: "#424040"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#424040"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25,
    width: 4,
    height: 2,
    rx: 0.5,
    transform: "rotate(-90 33 25)",
    fill: "#424040"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 9,
    height: 2,
    rx: 0.5,
    fill: "#424040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_1121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCam);
export default __webpack_public_path__ + "static/media/IconCam.4ff12f0da85b57ecf216e7ba483f3c6b.svg";
export { ForwardRef as ReactComponent };